interface DataCardsProps {
  focusMinutes: number;
  habitDone: number;
  habitTotal: number;
}

export default function DataCards({ focusMinutes, habitDone, habitTotal }: DataCardsProps) {
  const progress = habitTotal > 0 ? habitDone / habitTotal : 0;

  return (
    <div className="flex gap-3 px-4 mb-4">
      {/* Focus card */}
      <div
        className="flex-1 rounded-2xl p-4 relative overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.72)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.7)',
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 30% 30%, rgba(181,198,224,0.18) 0%, transparent 70%)' }}
        />
        <p className="text-xs mb-1 flex items-center gap-1" style={{ color: '#8E8E93' }}>
          <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: '#B5C6E0' }} />
          今日专注
        </p>
        <div className="flex items-end gap-1">
          <span className="font-bold tabular-nums" style={{ fontSize: 36, color: '#3D3D3D', lineHeight: 1 }}>
            {focusMinutes}
          </span>
          <span className="mb-1 text-sm" style={{ color: '#8E8E93' }}>分钟</span>
        </div>
        {/* Decorative ring */}
        <div className="mt-2 flex justify-end">
          <svg width="36" height="36" viewBox="0 0 36 36">
            <circle cx="18" cy="18" r="14" fill="none" stroke="rgba(181,198,224,0.2)" strokeWidth="3" />
            <circle
              cx="18" cy="18" r="14" fill="none"
              stroke="url(#focusGrad)" strokeWidth="3"
              strokeDasharray={`${2 * Math.PI * 14 * 0.72} ${2 * Math.PI * 14}`}
              strokeLinecap="round"
              transform="rotate(-90 18 18)"
            />
            <defs>
              <linearGradient id="focusGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#B5C6E0" />
                <stop offset="100%" stopColor="#C5B9D8" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      {/* Habit card */}
      <div
        className="flex-1 rounded-2xl p-4 relative overflow-hidden"
        style={{
          background: 'rgba(255,255,255,0.72)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.7)',
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 70% 30%, rgba(197,185,216,0.18) 0%, transparent 70%)' }}
        />
        <p className="text-xs mb-1 flex items-center gap-1" style={{ color: '#8E8E93' }}>
          <span className="w-1.5 h-1.5 rounded-full inline-block" style={{ background: '#C5B9D8' }} />
          习惯进度
        </p>
        <div className="flex items-end gap-1">
          <span className="font-bold tabular-nums" style={{ fontSize: 36, color: '#3D3D3D', lineHeight: 1 }}>
            {habitDone}
          </span>
          <span className="mb-1 text-sm" style={{ color: '#8E8E93' }}>/{habitTotal}</span>
        </div>
        <div className="mt-3 h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(181,198,224,0.2)' }}>
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{
              width: `${progress * 100}%`,
              background: 'linear-gradient(90deg,#B5C6E0,#C5B9D8)',
            }}
          />
        </div>
      </div>
    </div>
  );
}
